import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import TermsModal from '../TermsModal/TermsModal';
import './Footer.css';

const Footer = () => {
  const [isTermsOpen, setIsTermsOpen] = useState(false);

  return (
    <footer className="footer">
      <div className="footer__grid">

        {/* Brand */}
        <div className="footer__brand">
          <div className="footer__logo-name">
            <span className="c">CASH</span><span className="s">SOL</span>
          </div>
          <div className="footer__logo-sub">PRÉSTAMOS CON PROPÓSITO</div>
          <span className="footer__copy">© 2024 Cash Sol SAC. Todos los derechos reservados.</span>
          <p className="footer__sbs">
            Empresa registrada en la Superintendencia de Banca,
            Seguros y AFP (SBS). Operamos bajo estándares de
            transparencia y seguridad.
          </p>
        </div>

        {/* Menú */}
        <div className="footer__col">
          <h5>MENÚ</h5>
          <a href="#inicio">Inicio</a>
          <a href="#nosotros">Nosotros</a>
          <a href="#servicios">Servicios</a>
          <a href="#mapa">Contacto</a>
        </div>

        {/* Redes Sociales */}
        <div className="footer__col">
          <h5>REDES SOCIALES</h5>
          <a href="https://www.facebook.com/cashsolperu/?locale=es_LA" target="_blank" rel="noreferrer">
            <i className="fab fa-facebook"></i> Facebook
          </a>
          <a href="https://www.instagram.com/prestacashsoll/" target="_blank" rel="noreferrer">
            <i className="fab fa-instagram"></i> Instagram
          </a>
          <a href="https://www.tiktok.com/@presta.cash.sol" target="_blank" rel="noreferrer">
            <i className="fab fa-tiktok"></i> TikTok
          </a>
          <a href="https://www.linkedin.com" target="_blank" rel="noreferrer">
            <i className="fab fa-linkedin"></i> LinkedIn
          </a>
        </div>

        {/* Horario */}
        <div className="footer__col">
          <h5>HORARIO</h5>
          <div className="footer__day-group">
            <span className="footer__days">Lunes a Viernes</span>
            <span className="footer__hours">09:00 am - 06:00 pm</span>
          </div>
          <div className="footer__day-group">
            <span className="footer__days">Sábados</span>
            <span className="footer__hours">09:00 am - 01:00 pm</span>
          </div>
        </div>
      </div>

      {/* Bottom bar */}
      <div className="footer__bottom">
        <a href="#reclamaciones" className="footer__reclamos">
          <i className="fa-solid fa-book"></i> Libro de Reclamaciones
        </a>
        <button onClick={() => setIsTermsOpen(true)} className="footer__terms">
          <i className="fa-solid fa-file-contract"></i> Términos y condiciones clientes uso del portal
        </button>
        <Link to="/politica-privacidad" className="footer__terms">
          <i className="fa-solid fa-shield-halved"></i> Política de privacidad y protección de datos personales
        </Link>
      </div>

      <TermsModal isOpen={isTermsOpen} onClose={() => setIsTermsOpen(false)} />
    </footer>
  );
};

export default Footer;
